// extracted by mini-css-extract-plugin
module.exports = {"tab":"tab-module--tab--2OVBf","active":"tab-module--active--1IjDN"};